import { useNavigate } from 'react-router-dom';
import { LoginForm } from '@/pages/auth/LoginForm';
import { notify } from '@/core/toast/notify';

export function MasterLoginPage() {
  const navigate = useNavigate();

  return (
    <LoginForm
      variant="master"
      showRegisterLink={false}
      onLoginSuccess={(result) => {
        if (result.masterAdmin) {
          navigate('/master', { replace: true });
          return;
        }
        notify.error('This account is not a platform master administrator.');
      }}
    />
  );
}
